var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 " + _vm.size + " " + _vm.size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { filter: "url(#filter0_d_4739_57821)" } }, [
        _c("path", {
          attrs: {
            d:
              "M6.78673 8.125L11.9485 3.25H13.669V22.75H11.9485L6.78673 17.875H1.625V8.125H6.78673Z",
            fill: _vm.color
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M16.2615 8.125L19.7495 11.613L23.1558 8.20665L24.3049 9.3557L20.8986 12.762L24.3049 16.1683L23.1558 17.3174L19.7495 13.9111L16.2615 17.399L15.1125 16.25L18.6005 12.762L15.1125 9.27405L16.2615 8.125Z",
            fill: _vm.color
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c(
          "filter",
          {
            attrs: {
              id: "filter0_d_4739_57821",
              x: "-1",
              y: "-1",
              width: "30",
              height: "30",
              filterUnits: "userSpaceOnUse",
              "color-interpolation-filters": "sRGB"
            }
          },
          [
            _c("feFlood", {
              attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
            }),
            _vm._v(" "),
            _c("feColorMatrix", {
              attrs: {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }
            }),
            _vm._v(" "),
            _c("feOffset", { attrs: { dx: "1", dy: "1" } }),
            _vm._v(" "),
            _c("feGaussianBlur", { attrs: { stdDeviation: "1" } }),
            _vm._v(" "),
            _c("feComposite", { attrs: { in2: "hardAlpha", operator: "out" } }),
            _vm._v(" "),
            _c("feColorMatrix", {
              attrs: {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              }
            }),
            _vm._v(" "),
            _c("feBlend", {
              attrs: {
                mode: "normal",
                in2: "BackgroundImageFix",
                result: "effect1_dropShadow_4739_57821"
              }
            }),
            _vm._v(" "),
            _c("feBlend", {
              attrs: {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_dropShadow_4739_57821",
                result: "shape"
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a44d4e5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a44d4e5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/play_control/volume_off.vue
// module id = null
// module chunks = 